import { render } from "./Login.vue?vue&type=template&id=1646fe9f"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=1646fe9f&scroped=true&lang=css"

import exportComponent from "/Users/tycooper/Desktop/Coding/Suites/barkbadge/barkbadge-wholesale/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__